import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=7bcbad36&lang=html"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=7bcbad36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports